import { render, staticRenderFns } from "./ContactInfoAddresses.vue?vue&type=template&id=73459ed0"
import script from "./ContactInfoAddresses.vue?vue&type=script&lang=ts"
export * from "./ContactInfoAddresses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73459ed0')) {
      api.createRecord('73459ed0', component.options)
    } else {
      api.reload('73459ed0', component.options)
    }
    module.hot.accept("./ContactInfoAddresses.vue?vue&type=template&id=73459ed0", function () {
      api.rerender('73459ed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactInfoAddresses.vue"
export default component.exports